module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new2/sp/item_01_abf40adc79c2a4d702dd44ea98fffccc.jpg";